export function extractServerErrorMessage(error: unknown): string {
  if (!error) return 'Неизвестная ошибка'

  if (typeof error === 'string') return error

  if (error instanceof Error) return error.message

  if (typeof error === 'object') {
    const e = error as Record<string, unknown>

    if (e.data) {
      const data = e.data
      if (typeof data === 'string') return data
      if (typeof data === 'object' && data !== null) {
        const d = data as Record<string, unknown>
        if (typeof d.message === 'string') return d.message
        if (typeof d.details === 'string') return d.details
        if (typeof d.error === 'string') return d.error

        return JSON.stringify(data)
      }
    }

    if (typeof e.error === 'string') return e.error
    if (typeof e.message === 'string') return e.message
  }

  return 'Ошибка при сохранении на сервере'
}
